import React, { useEffect, useMemo, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Column } from 'primereact/column';
import { Tooltip } from 'primereact/tooltip';
import { formatNumbersToCurrencyString, validateNumericInput } from 'utils/utils';
import { getDepositInfoTooltipMessage, isDepositInfoDropdownDisabled } from '../../helpers/createInvoiceHelpersV2';

const AvailableTrustFundV2 = (props) => {
  const {
    selectedInvoice,
    trustBalance,
    trustAccountData,
    setTrustAccountData,
    formErrors,
    setFormErrors,
    accountList,
    totalAmount,
    depositInfo,
    setDepositInfo,
    setIsChanged,
    isDepositLocked = false,
    isEditMode = false,
  } = props || {};

  const [selectedDepositInto, setSelectedDepositInto] = useState();
  const [selectedDepositInfo, setSelectedDepositInfo] = useState();

  const tooltipMessage = useMemo(() => getDepositInfoTooltipMessage(isEditMode, isDepositLocked), [isEditMode, isDepositLocked]);

  const isDropdownDisabled = useMemo(() => isDepositInfoDropdownDisabled(isEditMode, isDepositLocked), [isEditMode, isDepositLocked]);

  useEffect(() => {
    if (!selectedDepositInto || !selectedDepositInfo) {
      setFormErrors((prev) => ({ ...prev, deposit_Info: '' }));
      return;
    }

    if (selectedDepositInto.account_id === selectedDepositInfo.account_id) {
      setFormErrors((prev) => ({ ...prev, deposit_Info: '' }));
    } else {
      if (selectedDepositInto.account_type === selectedDepositInfo.account_type) {
        setFormErrors((prev) => ({
          ...prev,
          deposit_Info: 'Cannot select two different accounts of the same type',
        }));
      } else {
        setFormErrors((prev) => ({ ...prev, deposit_Info: '' }));
      }
    }
  }, [selectedDepositInto, selectedDepositInfo]);

  return (
    <div>
      {/* TODO:doubt two tables are there */}
      {/* TODO:must fix direct state mutation */}
      {/* TODO:body and editor templates */}

      {!selectedInvoice && trustBalance?.trust_data?.length > 0 && trustAccountData && (
        <div className="mt-3">
          <div className="caption-bold mb-2">Trust Fund Allocation</div>
          <div className="card-bg row m-0 datatable-responsive" style={{ overflow: 'hidden' }}>
            <DataTable value={[trustAccountData]} className="p-datatable-responsive p-0">
              <Column
                header="Account"
                // body={(rowData, props) => {
                //   return (
                //     <>
                //       <span className="p-column-title text-break">Account</span>
                //       <span>
                //         <Dropdown
                //           options={trustBalance.trust_data}
                //           optionLabel="trust_account_name"
                //           value={{
                //             trust_account_id: rowData?.debit_account_id,
                //             trust_account_name: rowData?.debit_account_name,
                //             trust_balance: rowData?.amount_available,
                //           }}
                //           onChange={(e) => {
                //             trustAccountData.debit_account_id = e?.target?.value?.trust_account_id;
                //             trustAccountData.debit_account_name = e?.target?.value?.trust_account_name;
                //             trustAccountData.amount_available = e?.target?.value?.trust_balance;
                //             trustAccountData.amount_paid = 0;
                //             setTrustAccountData({ ...trustAccountData });
                //           }}
                //           className="input-shadow w-100"
                //           filter
                //         />
                //       </span>
                //     </>
                //   );
                // }}
                body={(rowData) => {
                  return (
                    <>
                      <span className="p-column-title text-break">Account</span>
                      <span className="text-break">{rowData?.debit_account_name}</span>
                    </>
                  );
                }}
              />
              <Column
                header="Amount Available"
                body={(rowData) => {
                  return (
                    <>
                      <span className="p-column-title text-break">Amount Available</span>
                      <span className="text-break">{formatNumbersToCurrencyString(rowData?.amount_available)}</span>
                    </>
                  );
                }}
              />
              <Column
                header="Amount To Apply"
                body={(rowData) => {
                  return (
                    <>
                      <span className="p-column-title text-break">Amount to Apply From Trust</span>
                      <span className="text-break">{formatNumbersToCurrencyString(rowData?.amount_paid)}</span>
                    </>
                  );
                }}
                editor={(props) => {
                  return (
                    <div>
                      <InputText
                        className="input-shadow w-50"
                        placeholder="amount"
                        type="text"
                        value={props?.rowData?.amount_paid ?? ''}
                        keyfilter="pnum"
                        onChange={(e) => {
                          const validatedValue = validateNumericInput(e.target.value);
                          trustAccountData.amount_paid = validatedValue;
                          setTrustAccountData({ ...trustAccountData });
                          formErrors.amount_paid = '';
                          setFormErrors({ ...formErrors });
                        }}
                      />
                      {formErrors?.amount_paid && <span className="text-danger">{formErrors?.amount_paid}</span>}
                    </div>
                  );
                }}
              />
              <Column
                header="Balance in Trust After Allocation"
                body={(rowData) => {
                  let amount_paid = rowData?.amount_paid;
                  let amount_available = rowData?.amount_available;
                  if (amount_paid && amount_available) {
                    let d = parseFloat(amount_available) - parseFloat(amount_paid);
                    return (
                      <>
                        <span className="p-column-title text-break">Balance in Trust After Allocation</span>
                        <span className="text-break">{formatNumbersToCurrencyString(d)}</span>
                      </>
                    );
                  } else {
                    return (
                      <>
                        <span className="p-column-title text-break">Balance in Trust After Allocation</span>
                        <span className="text-break">-</span>
                      </>
                    );
                  }
                }}
              />

              <Column
                header={<span>Deposit Into{Boolean(trustAccountData?.amount_paid) && <span className="text-danger">*</span>}</span>}
                body={(rowData) => {
                  return (
                    <>
                      <span className="p-column-title text-break">Deposit Into</span>
                      <span>
                        <Dropdown
                          className="input-shadow w-100"
                          options={accountList?.filter((account) => account?.account_id !== rowData?.debit_account_id)}
                          optionLabel="account_name"
                          optionValue={(v) => v}
                          value={
                            rowData?.credit_account_id
                              ? accountList?.find((a) => a?.account_id === rowData?.credit_account_id) ?? null
                              : null
                          }
                          onChange={(e) => {
                            const selected = e?.value ?? null;
                            if (!selected) {
                              setTrustAccountData({
                                ...trustAccountData,
                                credit_account_name: '',
                                credit_account_id: '',
                                account_type: '',
                              });
                              setSelectedDepositInto(null);
                            } else {
                              setTrustAccountData({
                                ...trustAccountData,
                                credit_account_name: selected?.account_name,
                                credit_account_id: selected?.account_id,
                                account_type: selected?.account_type,
                              });
                              setSelectedDepositInto(selected);
                            }
                            setFormErrors((prev) => ({ ...prev, credit_account_name: '' }));
                          }}
                          filter
                          showClear={!!rowData?.credit_account_id}
                          placeholder="Select"
                        />
                        {formErrors?.credit_account_name && <span className="text-danger">{formErrors?.credit_account_name}</span>}
                      </span>
                    </>
                  );
                }}
              />
            </DataTable>
          </div>
        </div>
      )}
      <div className="card-bg p-3 align-self-start mt-4">
        <div className="d-flex flex-wrap gap-3 align-items-baseline">
          <div className="d-flex align-items-center">
            <div className="p-medium me-2 t-bold">Remaining Amount Due:</div>
            <span className="t-bold">{formatNumbersToCurrencyString(totalAmount - (trustAccountData?.amount_paid || 0))}</span>
          </div>
          <div className="d-flex">
            <div className="p-medium me-2 mt-2 d-inline-flex align-items-center flex-shrink-0 gap-0">
              <span>
                Deposit Info
                {totalAmount - (trustAccountData?.amount_paid || 0) > 0 && <span className="text-danger">*</span>}
              </span>
              <i
                className="pi pi-info-circle text-muted cursor-pointer deposit-info-tip-invoice flex-shrink-0 align-middle"
                style={{ fontSize: '12px', lineHeight: 1, padding: '5px' }}
                aria-label="More information"
                role="img"
              />
            </div>
            <div className="d-flex flex-column">
              <Dropdown
                options={accountList || []}
                optionLabel="account_name"
                optionValue="account_id"
                className="input-shadow"
                placeholder="Deposit Info"
                value={depositInfo}
                disabled={isDropdownDisabled}
                onChange={(e) => {
                  setDepositInfo(e.value);
                  setIsChanged((preVal) => ({ ...preVal, invoice: true }));
                  setFormErrors((preval) => ({ ...preval, deposit_Info: '' }));
                  setSelectedDepositInfo(accountList?.find((account) => account?.account_id === e?.value));
                }}
              />
              {formErrors?.deposit_Info && <span className="text-danger small mt-1">{formErrors?.deposit_Info}</span>}
            </div>
          </div>
          <Tooltip target=".deposit-info-tip-invoice" content={tooltipMessage} position="top" showDelay={300} />
        </div>
      </div>

      {selectedInvoice && trustAccountData?.amount_paid && (
        <div className="d-flex py-2 flex-wrap time-entries mt-4">
          <div className="col-12 caption-bold mb-3">Available Trust Funds</div>
          <div className="col-12 shadow-small">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Account</th>
                  <th>Amount Paid</th>
                  <th>Deposit Into</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{trustAccountData?.debit_account_name}</td>
                  <td>{trustAccountData?.amount_paid}</td>
                  <td>{trustAccountData?.credit_account_name}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default AvailableTrustFundV2;
